import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function ServiceCard({ service, index = 0 }) {
    const Icon = service.icon;
    return (
        <Reveal delay={Math.min(index * 0.07, 0.4)} className="h-full">
            <div
                className="group flex h-full flex-col border border-slate-200 bg-white p-8 transition-colors duration-300 hover:border-navy hover:bg-navy"
                data-testid={`service-card-${service.short.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
                <div className="mb-6 flex h-12 w-12 items-center justify-center border border-slate-200 text-navy transition-colors duration-300 group-hover:border-amber group-hover:text-amber">
                    <Icon size={22} strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-lg font-bold tracking-tight text-navy transition-colors duration-300 group-hover:text-white">
                    {service.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600 transition-colors duration-300 group-hover:text-slate-300">
                    {service.description}
                </p>
                <Link
                    to={service.link}
                    className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-amber transition-colors duration-300 hover:text-amber-hover group-hover:text-amber"
                    data-testid={`service-learn-more-${service.short.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                    Learn More
                    <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
            </div>
        </Reveal>
    );
}
